import { instance } from './instance';
import { ApiDeleteWorkspaceUserProps, ApiSuccessGetProject, ApiSuccessGetWorkspace } from '@/dashboard/api/types/apiTypes';

export const WorkspaceApi = {
  getById: async (id: number): Promise<ApiSuccessGetWorkspace> => {
    const params = {
      id: id,
    };
    const response = await instance.get('/app/workspace/workspace', { params: params });
    return response.data;
  },
  getByShortLink: async (shortLink: string): Promise<ApiSuccessGetWorkspace> => {
    const params = {
      short_link: shortLink,
    };
    const response = await instance.get('/app/workspace/workspace', { params: params });
    return response.data;
  },
  deleteUser: async ({ workspaceShortLink, keepPersonalData, userId }: ApiDeleteWorkspaceUserProps): Promise<ApiSuccessGetWorkspace> => {
    const formData = new FormData();
    formData.append('short_link', workspaceShortLink);
    formData.append('user_id', `${userId}`);
    formData.append('keep_personal_data', `${keepPersonalData}`);
    const response = await instance.post(`/app/workspace/delete_user`, formData);
    return response.data;
  },
  canCreateProject: async (shortLink: string): Promise<ApiSuccessGetWorkspace & { can_create_project: boolean }> => {
    const params = {
      short_link: shortLink,
    };
    const response = await instance.get('/app/workspace/can_create_project', { params: params });
    return response.data;
  },
};
